<div
  [ngClass]="{ 'flex-column': isColumn }"
  class="d-flex border border-primary bg-light-blue rounded-1 bg-light p-1 w-100"
  style="margin-left: 1px">
  <button
    *ngFor="let option of options; index as i"
    (click)="onSelectOption(option.key)"
    [ngClass]="{
      'mb-1': isColumn && i !== options.length - 1,
      'w-100': isColumn,
      'flex-grow-1': !isColumn
    }"
    class="btn btn-sm d-flex justify-content-center text-center"
    [class.btn-primary]="selectedOption === option.key"
    [class.btn-transparent]="selectedOption !== option.key">
    {{ option.label }}
  </button>
</div>
